import React, { useState, useEffect, Suspense } from 'react';
import { Layout, Typography, Spin } from 'antd';
import { AppHeader, Sidebar } from './dashboard';
import { Outlet, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useSubscription } from '@apollo/client';
import { USER_ONLINE_STATUS_SUBSCRIPTION, ALL_USERS_ONLINE_STATUS_SUBSCRIPTION } from '../graphql/subscriptions';

const { Title } = Typography;

const Dashboard = () => {
  const [selectedKey, setSelectedKey] = useState('1');
  const [collapsed, setCollapsed] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [userId, setUserId] = useState(null);
  const [onlineUsers, setOnlineUsers] = useState(new Set());
  const navigate = useNavigate();

  // Подписка на свой статус — только после userId
  useSubscription(USER_ONLINE_STATUS_SUBSCRIPTION, {
    skip: !userId,
    variables: { userId },
    shouldResubscribe: false,
    onData: ({ data }) => {
      const update = data?.data?.userOnlineStatusChanged;
      // здесь можно обновлять что-то своё, если нужно
    },
    onError: (err) => console.error('Subscription error:', err),
  });

  // Подписка на статусы всех пользователей
  useSubscription(ALL_USERS_ONLINE_STATUS_SUBSCRIPTION, {
    shouldResubscribe: false,
    onData: ({ data }) => {
      const update = data?.data?.allUsersOnlineStatusChanged;
      if (!update) return;
      setOnlineUsers((prev) => {
        const updated = new Set(prev);
        if (update.isOnline) {
          updated.add(update.userId);
        } else {
          updated.delete(update.userId);
        }
        return updated;
      });
    },
    onError: (err) => console.error('Subscription error:', err),
  });

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { navigate('/login'); return; }
    try {
      const decodedToken = jwtDecode(token);
      if (decodedToken.exp * 1000 < Date.now()) {
        localStorage.removeItem('token');
        navigate('/login');
        return;
      }
      setUserRole(decodedToken.roles?.[0]?.toUpperCase() || 'UNKNOWN');
      setUserId(decodedToken.id);
    } catch (error) {
      console.error('Ошибка при декодировании токена:', error);
      localStorage.removeItem('token');
      navigate('/login');
    }
  }, [navigate]);

  const handleCollapse = (collapsed) => setCollapsed(collapsed);

  return (
    <Layout style={{ minHeight: '100vh', background: '#ffffff' }}>
      <Sidebar
        setSelectedKey={setSelectedKey}
        collapsed={collapsed}
        onCollapse={handleCollapse}
        userRole={userRole}
        userId={userId}
      />
      <Layout>
        <AppHeader />
        <div style={{ padding: 16, background: '#fff' }}>
          <Title level={4}>
            Онлайн пользователей: {onlineUsers.size}
          </Title>
        </div>
        <Suspense fallback={<Spin style={{ margin: '20px auto', display: 'block' }} />}>
          <Outlet context={{ userRole, userId }} />
        </Suspense>
      </Layout>
    </Layout>
  );
};

export default Dashboard;
